import React from 'react'
import PropTypes from 'prop-types'
import ContentNotFoundBanner from './contentNotFoundBanner'
import {isPreviewOrDev} from './previewEnv'

// Lazy to keep PageNotFound out of the static import graph (it renders
// <Optimizely>, which renders this) and to avoid SSR issues — same pattern the
// Optimizely component used previously.
const PageNotFound = React.lazy(() => import('../../../pages/page-not-found'))

/* Shared fallback for any Optimizely-driven page whose (brand, locale, key)
 * tree has no authored content:
 *   - dev / preview → diagnostic banner naming exactly what's missing
 *   - production    → the standard error page
 *
 * The error page itself passes showErrorPage={false} so the missing-error-page
 * case resolves to the banner (dev) or null (prod) instead of recursing into
 * PageNotFound → Optimizely → PageNotFound forever. */
const ContentFallback = ({contentKey, note, showErrorPage = true}) => {
    if (isPreviewOrDev()) {
        return <ContentNotFoundBanner contentKey={contentKey} note={note} />
    }
    if (!showErrorPage) {
        return null
    }
    return (
        <React.Suspense fallback={null}>
            <PageNotFound />
        </React.Suspense>
    )
}

ContentFallback.propTypes = {
    contentKey: PropTypes.string,
    note: PropTypes.node,
    showErrorPage: PropTypes.bool
}

export default ContentFallback
